import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Vega from 'react-vega';
import { Modal, Glyphicon, Tooltip } from 'react-bootstrap';
import { get, map, filter, isEmpty } from 'lodash';

import activityCountSpecs from './hottest-moments.json';
import memeCountSpecs from './hottest-moments2.json';

import Comment from '../../pages/ShowReport/CommentFeed/Comment';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import Filter from '../../components/Filters/Filter';

import './styles.css';

class HottestMoments extends React.Component {
  constructor(props) {
    super(props);

    this.ref = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.getChartSpecs = this.getChartSpecs.bind(this);
    this.handleDropdownChange = this.handleDropdownChange.bind(this);

    this.state = {
      showModal: false,
      showTooltip: false,
      screencap: '',
      tooltipPosX: 0,
      tooltipPosY: 0,
      placement: 'top',
      spec: { label: 'Engagements', value: 'activityCount', id: 'metric' }
    };
  }

  handleClick(...args) {
    const signalName = args[0];
    const datum = args[1];
    const screencapId = get(datum, ['screencapId'], false);

    if (signalName === 'clickTimestamp' && screencapId) {
      this.props.fetchMemes(screencapId);
      this.setState({
        showModal: true
      });
    }
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleHover(...args) {
    const event = get(args, [1, 0], '');

    if (isEmpty(event)) {
      this.setState({
        showTooltip: false,
        screencap: '',
        tooltipPosX: 0,
        tooltipPosY: 0,
        placement: 'top'
      });
    } else {
      const boxHalfWidth = 83;
      let posX = event.offsetX - boxHalfWidth;
      let posY = event.offsetY - 25;
      let placement = 'top';
      let arrowOffsetLeft = '50%';

      const rightLimit =
        this.ref.current.parentNode.parentNode.scrollLeft +
        this.ref.current.offsetWidth -
        boxHalfWidth * 2;

      if (posX < 0) {
        arrowOffsetLeft = posX + boxHalfWidth;
        posX = 0;
      } else if (posX > rightLimit) {
        arrowOffsetLeft = posX + boxHalfWidth - rightLimit;
        posX = rightLimit;
      }

      if (posY < 120) {
        posY += 200;
        placement = 'bottom';
      }

      const activityCount = get(args, [1, 1, 'activityCount']);
      const memeCount = get(args, [1, 1, 'memeCount']);
      const screencap = get(args, [1, 1, 'screencapImageUrl']);

      this.setState({
        activityCount,
        arrowOffsetLeft,
        memeCount,
        placement,
        screencap,
        showTooltip: true,
        tooltipPosX: posX,
        tooltipPosY: posY
      });
    }
  }

  getChartSpecs = name => {
    switch (name) {
      case 'activityCount':
        return activityCountSpecs;
      case 'memeCount':
        return memeCountSpecs;
      default:
        return activityCountSpecs;
    }
  };

  handleDropdownChange = (_, value) => {
    this.setState({ spec: value });
  };

  renderTooltip = () => (
    <Tooltip
      id="tvt-visualization__hottest-moments__tooltip"
      className="tvt-visualization__hottest-moments__tooltip in"
      placement={this.state.placement}
      style={{
        left: this.state.tooltipPosX,
        bottom: `calc(100% - ${this.state.tooltipPosY}px)`
      }}
      arrowOffsetLeft={this.state.arrowOffsetLeft}
    >
      <span>Engagements: {this.state.activityCount}</span>
      <span>Memes: {this.state.memeCount}</span>
      <img src={this.state.screencap} alt="" />
    </Tooltip>
  );

  render() {
    const { memes, fetchMemesStatus, loading } = this.props;
    const isLoaded = !!get(this.props, 'data.data.length', false);

    if (loading || !isLoaded) {
      return (
        <div
          className="tvt-time-chart__loading-state-wrapper hottest-moment-loader"
          style={{ backgroundColor: '#ffffff' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1066"
            height="426"
            viewBox="0 0 1066 426"
          >
            <defs>
              <linearGradient
                id="dh9frx00na"
                x1="0%"
                x2="100%"
                y1="50%"
                y2="50%"
              >
                <stop offset="0%" stopColor="#EEEEEE" />
                <stop offset="33%" stopColor="#EEEEEE" />
                <stop offset="50%" stopColor="#f5f5f5" />
                <stop offset="67%" stopColor="#EEEEEE" />
                <stop offset="100%" stopColor="#EEEEEE" />
                <animateTransform
                  attributeName="gradientTransform"
                  type="translate"
                  from="-1 0"
                  to="1 0"
                  begin="0s"
                  dur="1.5s"
                  repeatCount="indefinite"
                />
              </linearGradient>
            </defs>
            <path
              fill="url(#dh9frx00na)"
              fillRule="evenodd"
              d="M140 416v10H90v-10h50zm173 0v10h-50v-10h50zm168 0v10h-50v-10h50zm162 0v10h-50v-10h50zm159 0v10h-50v-10h50zm189 0v10h-50v-10h50zM625.418 184v221h3V246h4v159h2V267h4v138h2V246h4v159h2V267h4v138h2V246h4v159h2V226h4v179h2V184h4v221h2V246h4v159h2V246h4v159h7v1h-139v-1h7v-33h4v33h2v-25h4v25h2v-9h4v9h2v-9h4v9h2v-17h4v17h2v-17h4v17h2v-17h4v17h2v-33h4v33h2v-88h4v88h2V246h4v159h2V226h4v179h2V184h4zm331-139v360h2V45h4v360h2V45h4v360h2V83h4v322h2V85h4v320h2V45h4v360h2V83h4v322h2V45h4v360h2V83h4v322h3V85h4v320h2V85h4v320h2V111h4v294h2V123h4v282h2V123h4v282h2V184h4v221h2V204h4v201h2V246h4v159h2V267h4v138h7v1h-200v-1h7v-33h4v33h2v-25h4v25h2v-9h4v9h2v-9h4v9h2v-17h4v17h3v-17h4v17h2v-17h4v17h2v-33h4v33h2v-88h4v88h2V246h4v159h2V226h4v179h2V184h4v221h2V85h4v320h2V45h4zm-685 28v332h3V109h4v296h2V202h4v203h2V240h4v165h2V259h4v146h2v-82h4v82h2v-31h4v31h2v-15h4v15h2v-15h4v15h2v-15h4v15h2v-9h4v9h2v-9h4v9h2v-23h4v23h2v-31h4v31h2v-49h4v49h7v1h-151v-1h7V277h4v128h2V259h4v146h2V220h4v185h2V202h4v203h2V145h4v260h2V145h4v260h2V133h4v272h2V109h4v296h2V73h4zm-236-73v405h157v1h-158V0h1zm438 2v403h2V85h4v320h2V111h4v294h2V123h4v282h2V123h4v282h2V184h4v221h2V204h4v201h2V246h4v159h2V267h4v138h7v1h-145v-1h7v-33h4v33h2v-25h4v25h2v-9h4v9h2v-9h4v9h2v-17h4v17h2v-17h4v17h2v-17h4v17h2v-33h4v33h2v-88h4v88h2V246h4v159h2V226h4v179h2V184h4v221h2V85h4v320h3V2h4zm257 202v201h2V242h4v163h2V261h4v144h2V279h4v126h2V261h4v144h2V279h4v126h2V261h4v144h3V204h4v201h2V242h4v163h2V261h4v144h2v-80h4v80h2v-29h4v29h2v-15h4v15h2v-15h4v15h2v-15h4v15h2v-9h4v9h2v-9h4v9h2v-23h4v23h2v-29h4v29h7v1h-139v-1h7V261h4v144h2V261h4v144h2V204h4zm-545 80v121h-4V284h4zm-66-59v180h-4V225h4zm-67 0v180h-4V225h4zm61-22v202h-4V203h4zm-55-22v224h-4V181h4zm43-135v359h-4V46h4zm-13 0v359h-4V46h4zm-6 28v331h-4V74h4zm12-53v384h-4V21h4zm-18 69v315h-4V90h4zm31 69v246h-4V159h4zm-43 0v246h-4V159h4zm6-69v315h-4V90h4zm55 214v101h-4V304h4zm42 71v30h-4v-30h4zm-12 18v12h-4v-12h4zm6 0v12h-4v-12h4zm-12-8v20h-4v-20h4zm-6 0v20h-4v-20h4zm-6 0v20h-4v-20h4zm36-20v40h-4v-40h4zm-42 0v40h-4v-40h4zm48-21v61h-4v-61h4zm-133-97v158h-4V247h4zm-32-90v90h-14v-90h14z"
              transform="translate(-.418)"
            />
          </svg>
        </div>
      );
    }

    return (
      <Fragment>
        <div className="cvmi-hottest-moments__faux-axis-wrapper">
          <div className="cvmi-hottest-moments__faux-axis">
            <div className="cvmi-hottest-moments__faux-axis-label">
              {this.state.spec.label}
            </div>
          </div>
        </div>
        <div className="cvmi-hottest-moments__toggle">
          Metric:
          <Filter
            className="tvt-filter cvmi-hottest-moments__toggle-dropdown"
            onChange={this.handleDropdownChange}
            id="metric"
            options={[
              { label: 'Engagements', value: 'activityCount', id: 'metric' },
              { label: 'Memes', value: 'memeCount', id: 'metric' }
            ]}
            value={this.state.spec}
            hasBoolean={false}
          />
        </div>
        <div className="static-modal">
          <Modal show={this.state.showModal} onHide={this.handleClose}>
            <Modal.Header>
              <Glyphicon
                className="tvt-modal__close-btn"
                onClick={this.handleClose}
                glyph="remove"
              />
            </Modal.Header>

            <Modal.Body>
              {fetchMemesStatus === 'pending' ? (
                <div className="tvt-comment-feed__loading-spinner">
                  <LoadingSpinner />
                </div>
              ) : (
                map(
                  filter(memes.data, m => m.memeUrl !== null),
                  (m, index) => (
                    <Comment
                      key={`hottest-moment-meme-comment-${index}`}
                      content={m.commentText}
                      image={m.memeUrl}
                      likesCount={m.likes}
                      date={m.commentDate}
                      style={{}}
                      repliesCount={m.replies}
                      sharesCount={m.shares}
                      isLoading={false}
                    />
                  )
                )
              )}
            </Modal.Body>
          </Modal>
        </div>
        <div
          ref={this.ref}
          className="tvt-visualization tvt-visualization__hottest-moments exportable"
        >
          {this.state.showTooltip && this.renderTooltip()}
          <Vega
            spec={this.getChartSpecs(this.state.spec.value)}
            data={{ table: get(this.props, 'data.data', []) }}
            onSignalClickTimestamp={this.handleClick}
            onSignalHover={this.handleHover}
          />
        </div>
      </Fragment>
    );
  }
}

HottestMoments.propTypes = {
  data: PropTypes.shape({}).isRequired, // eslint-disable-line react/no-unused-prop-types
  loading: PropTypes.bool,
  fetchMemes: PropTypes.func.isRequired,
  memes: PropTypes.shape({}).isRequired,
  fetchMemesStatus: PropTypes.string.isRequired
};

HottestMoments.defaultProps = {
  loading: false
};

export default HottestMoments;
